<template>
  <div id="svg-container">
    <svg :id="id"></svg>
    <div class="mt-auto" style="background-color: transparent;">
      <div class="row">
        <div class="col-lg-1">
          <!-- pulsante prev -->
          <div style="cursor: pointer; color: rgb(54, 96, 121);" @click.prevent="prevMethod" ><i class="fa fa-angle-left" aria-hidden="true" style="cursor: pointer; color: rgb(54, 96, 121);"></i>&nbsp;PREV</div>
        </div>
        <div class="col-lg-2">
          <!-- spazio vuoto a sinistra della scrollbar/slider -->
        </div>
        <div class="col-lg-6">
          <!-- scrollbar/slider -->
        </div>
        <div class="col-lg-2">
          <!-- zoom >
          <i class="fa fa-search-minus" aria-hidden="true" style="cursor: pointer; color: rgb(54, 96, 121);"  @click.prevent="zoomOut" v-if="globalBarWidth > minZoom"></i>
          <span style="color: rgb(54, 96, 121);">&nbsp;ZOOM&nbsp;</span>
          <i class="fa fa-search-plus" aria-hidden="true" style="cursor: pointer; color: rgb(54, 96, 121);" @click.prevent="zoomIn" v-if="globalBarWidth < maxZoom"></i-->
        </div>
        <div class="col-lg-1">
          <!-- pulsante next -->
          <div style="cursor: pointer; color: rgb(54, 96, 121);" @click.prevent="nextMethod" >NEXT&nbsp;<i class="fa fa-angle-right" aria-hidden="true" style="cursor: pointer; color: rgb(54, 96, 121);" @click.prevent="next" ></i></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as d3 from "d3";
import _ from "lodash";

const margin = 50;

export default {
  props: ["issues","graphicTitle","router","route-name","propertyName","filtroRicerca","prevMethod","nextMethod","filterDB"],
  data() {
    return {
      id: null,
      chart: null,
      noDataSentence: null,
      globalBarWidth: null,
      minZoom: 20,
      maxZoom: 30,
      svg: null,
      doRender: false,
    };
  },
  watch: {
    issues(val) {
      if (this.chart != null) this.chart.remove();
      if (this.noDataSentence != null) this.noDataSentence.remove();
      this.renderChart();
    }
  },
  methods: {
    /* N.B. Funziona solo per grafico tipologia_premio di vita-protezione che non è un vero e proprio StackedBarChart */
    renderChart() {
      console.log(" tpbc " + JSON.stringify(this.issues));

      this.doRender = this.issues !== undefined && this.issues !== null && this.issues.length > 0;
      if (this.issues !== undefined && this.issues.length >= 0) {
        this.doRender = this.issues.filter(e => e.value != undefined && parseInt(e.value) > 0).length > 0;
      }

      if (this.issues != undefined) {
        const svgWidth = 1100;
        const svgHeight = 530;

        this.svg = d3
          .select("#" + this.id)
          .attr("class", "chart")
          .attr("width", "100%")
          .attr("height", "97%");

        if (this.chart) {
          this.chart.remove();
        }

        window.addEventListener("resize", this.drawFunction);

        /*const zIn = this.zoomIn;
        const zOut = this.zoomOut;
        this.svg.on("mousewheel.zoom", function(event) {
          if (event.deltaY < 0) {
            zIn();
          } else if (event.deltaY > 0) {
            zOut();
          }
          event.preventDefault();
        });*/

        this.drawFunction();
      }
    },
    zoomed({transform}) {
      transform.y = 0;
      d3.select("#" + this.id)
        .select("g")
        .attr("transform", transform);
    },
    drawFunction() {
      console.log("draw " + this.graphicTitle);

      let router = this.router;
      const routeName = this.routeName
      const filtroRicerca = this.filtroRicerca;
      const propertyName = this.propertyName;

      const _filterDB = this.filterDB;

      //
      if (this.globalBarWidth === undefined || this.globalBarWidth === null) {
        this.globalBarWidth = this.maxZoom;
      }
      const barWidth = this.globalBarWidth;      

      let ricorrente = 0;
      let unico = 0;
      this.issues.forEach(i => {
        if (i.description == "Annuo") {
          ricorrente += Number(i.value);
        } else if (i.description == "Mensile") {
          ricorrente += Number(i.value);
        } else if (i.description == "Unico") {
          unico = Number(i.value);
        }
      });
      const data = [
        {category: "Ricorrente", "Serie1": ricorrente},
        {category: "Unico", "Serie1": unico},
      ];

      const columns = ["category", "Serie1"];

      const seriesAux = d3.stack().keys(columns.slice(1))(data);

      let ricorrenteInterval = seriesAux[0][0];
      let unicoInterval = seriesAux[0][1];
      /*
        [
            [
                'Annuo':[0,3],
                'Unico':[0,1]
            ],
            [   
                'Mensile':[3,5],
                'undef':[1,1]
            ]
        ]
      */
      let series = [
        [{'Ricorrente':ricorrenteInterval},{'Unico':unicoInterval}],
      ];

      //
      d3.selectAll(".data-tooltip").remove();
      var tooltip = d3.select("body")
        .append("div")
        .attr("class", "chart-tooltip data-tooltip")
        .style("opacity", 0);

      //
      const bounds = this.svg.node().getBoundingClientRect();

      if (bounds === undefined || bounds.width == 0 || bounds.height == 0) {
        return;
      }

      const chartWidth = bounds.width - 2 * margin;
      const chartHeight = bounds.height - 2 * margin;

      this.svg.selectChild("g").remove();
      this.svg.selectChild("defs").remove(); 

      this.svg.append('defs')
        .append('clipPath')
        .attr('id', 'clip')
        .append('rect')
        .attr('x', 0)
        .attr('y', 0)
        .attr('width', chartWidth)
        .attr('height', chartHeight);

      if (this.noDataSentence) {
        this.noDataSentence.remove();
      }
      if (!this.doRender) {
        this.noDataSentence = this.svg
          .append("text")
          .text("Non ci sono dati da rappresentare")
          .attr("x", chartWidth/2 + margin)
          .attr("y", chartHeight/2 - 2*margin)
          .style("font-size", "2rem")
          .style("fill", "#366079")
          .style("text-anchor", "middle");

        return;
      }

      const colors = d3.scaleOrdinal().domain(series).range(["#366079", "#679dba"])

      this.chart = this.svg
        .append("g")
        .attr("transform", `translate(${margin}, 0)`);

      var xScaleRange = 2 * barWidth;

      let xRange = [chartWidth / 2 - xScaleRange, chartWidth / 2 + xScaleRange];
      if (xScaleRange > chartWidth) {
        xRange = [0, chartWidth];
      }

      const xScale = d3.scaleBand()
        .domain(data.map(function(d) {
          return d.category;
        }))
        .range(xRange)
        .padding(0.1);
      
      const yScale = d3.scaleLinear()
        .domain([0,d3.max(series, d => d3.max(d, d=> d[Object.keys(d)[0]][1]))])
        .range([chartHeight,0]);

      const rects = this.chart
        .selectAll("g")
        .data(series)
        .enter()
        .append("g");

      rects.selectAll("rect")
        .data(d => d)
        .join("rect")
        .attr("x", (d, i) => {
          return xScale(d[Object.keys(d)[0]].data.category)
        })
        .attr("y", d=> yScale(d[Object.keys(d)[0]][1]))
        .attr("height", d=> yScale(d[Object.keys(d)[0]][0]) - yScale(d[Object.keys(d)[0]][1]))
        .attr("width", xScale.bandwidth())
        .attr("fill", d => {
          return colors(d[Object.keys(d)[0]]);
        })
        .on("mouseover", function(event, d) {
          d3.select(this)
            .attr("stroke-width", 3)
            .attr("stroke", "red")
            .attr("cursor", "pointer");

          tooltip.transition()
            .duration(200)
            .style("opacity", 1);
          let dVal = d[Object.keys(d)[0]][1];
          const t = Object.keys(d)[0] + ` : ${dVal}`;
          tooltip.html(t)
            .style("left", (event.pageX) + "px")
            .style("top", (event.pageY - 28) + "px");
        })
        .on("mouseout", function() {
          d3.select(this)
            .attr("stroke", "none")
            .attr("cursor", "default");

          tooltip.transition()
            .duration(200)
            .style("opacity", 0);
        })
        .on("click", function (d,i) {
          let description = Object.keys(i)[0];

          let values = [];
          if (description === "Ricorrente") {
            values = [{code:'22.1', description:"Annuo"},{code:'22.2', description:"Mensile"}];
          } else if (description === "Unico") {
            values = [{code:'22.3', description:"Unico"}];
          }

          var f = {
            key: propertyName,
            values: values,
          }

          _filterDB(f);
        });

      const xAxis = d3.axisBottom(xScale);
      this.chart
        .append("g")
        .attr("class", "axis x-axis")
        .attr("transform", `translate(0, ${chartHeight})`)
        .call(xAxis);

      const yAxis = d3.axisLeft(yScale);

      let maxY = _.maxBy(data, function(o) {
        let val = Number(o['Serie1']);
        return val;
      });

      const tickY = Number(maxY['Serie1']);
      /*this.chart
        .append("g")
        .attr("class", "axis y-axis")
        .attr('transform', `translate(${xRange[0]}, 0)`)
        .call(yAxis.ticks(tickY));*/

      let xScaleRicorrente = undefined;
      let yRicorrente = undefined;
      this.chart
        .selectAll("text .item-label")
        .data(data)
        .enter()
        .append("text")
        .attr("class", "item-label")
        .text((d) => {
          return d["Serie1"];
        })
        .attr("x", function(d, i) {
          return xScale(d.category);
        })
        .attr("y", function(d) {
          const h = chartHeight - yScale(d["Serie1"])
          if (h < 20) {
            return yScale(d["Serie1"]) - 10;
          }
          return yScale(d["Serie1"]) + 15;
        })
        .attr("dx", xScale.bandwidth() / 2)
        .attr("font-size", "12px")
        .attr("fill", function (d) {
          const h = chartHeight - yScale(d["Serie1"])
          if (h < 20) {
            return "black";
          }
          return "white";
        })
        .attr("text-anchor", "middle")
        .attr("dominant-baseline", "central");

      // adding labels
      this.svg
        .append('text')
        .attr('class', 'label')
        .attr('x', -(chartHeight / 2) - margin)
        .attr('y', margin / 2.4)
        .attr('transform', 'rotate(-90)')
        .attr('text-anchor', 'middle')
        .attr('stroke', '#366079')
        .text('')

      this.svg
        .append('text')
        .attr('class', 'label')
        .attr('x', chartWidth / 2 + margin)
        .attr('y', chartHeight + margin * 1.7)
        .attr('text-anchor', 'middle')
        .text('')

      // graphic title
      /*svg
        .append('text')
        .attr('class', 'title')
        .attr('x', chartWidth / 2 + margin)
        .attr('y', 40)
        .attr('text-anchor', 'middle')
        .attr('stroke', '#366079')
        .style("text-shadow", "none")
        .text(graphicTitle)*/

      const zoom = d3.zoom()
        .scaleExtent([1, 40])
        .on("zoom", this.zoomed);

      // tick
      this.svg.selectAll('.x-axis g.tick text')
        .attr("y", 0)
        .attr("x", 0)
        .attr("dy", "1.5em")
        .attr("dx", "0em")
        .attr("transform", "rotate(0)")
        .style("text-anchor", "middle");

      //svg.call(zoom);
    },
    zoomIn() {
      this.globalBarWidth += 2;
      this.globalBarWidth = this.globalBarWidth > this.maxZoom ? this.maxZoom : this.globalBarWidth;
      this.drawFunction();
    },
    zoomOut() {
      this.globalBarWidth -= 2;
      this.globalBarWidth = this.globalBarWidth < this.minZoom ? this.minZoom : this.globalBarWidth;
      this.drawFunction();
    }
  },
  created() {
    this.id = "uid" + this._uid;
  },
  mounted() {
    this.renderChart();
  },
  beforeDestroy() {
    d3.selectAll(".data-tooltip").remove();
    if (this.chart) {
      this.chart.remove();
    }
    window.removeEventListener("resize", this.drawFunction);    
  },
};
</script>

<style lang="scss">
#svg-container {
  height: 100%;
}
</style>